import * as React from "react";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Box } from "@mui/material";

const CheckoutForm = forwardRef((props, ref) => {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useImperativeHandle(ref, (e) => ({
        submit(newStep, isLast) {
            handleSubmit(undefined, newStep, isLast);
        },
    }));

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const query = new URLSearchParams(window.location.search);
        const paymentError = query.get("paymentError");
        const errorcode = query.get("errorcode");
        if (paymentError === "yes") {
            if (errorcode) {
                if (errorcode === "requires_payment_method") {
                    setMessage("Your payment was not successful, please try again.");
                } else {
                    setMessage("Something went wrong. please try again.");
                }
            } else {
                setMessage("Something went wrong. please try again.");
            }
        }

        const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e, newStep, isLast) => {
        e?.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        let url = process.env.REACT_APP_STRIP_REDIRECT_URL?.replace("application-completion", "payment");
        let returnURL = "";
        if (isLast) {
            returnURL =
                url + `?amount=${props.amount}&promocode=${props.promocode ? props.promocode.Id : ""}&callback=last`;
        } else {
            returnURL =
                url +
                `?amount=${props.amount}&promocode=${props.promocode ? props.promocode.Id : ""}&callback=${
                    newStep.key
                }`;
        }
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: returnURL,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: "tabs",
    };

    return (
        <form id="payment-form">
            {<PaymentElement id="payment-element" options={paymentElementOptions} />}

            {/* <button disabled={isLoading || !stripe || !elements} id="submit">
                <span id="button-text">{isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}</span>
            </button> */}
            {/* Show any error or success messages */}
            {message && (
                <Box
                    sx={{
                        color: "red",
                        lineHeight: "20px",
                        paddingTop: "12px",
                        textAlign: "center",
                    }}>
                    {message}
                </Box>
            )}
        </form>
    );
});
export { CheckoutForm };
